module.exports = __webpack_public_path__ + "img/tooltip_01-vallone-nano-all.683a109e.jpg";